<template>
    <v-expansion-panel key="itemKey" :value="lazyVal">
      <v-expansion-panel-header> {{headline}} </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-card>
          <v-card-text>
            <span>{{text}}</span>
            <v-autocomplete
              v-model="lazyVal"
              :item-text="itemText"
              :item-value="itemValue"
              :loading="loading"
              :search-input.sync="search"
              :items="items"
              @input="(val) => $emit('input', {[type]: lazyVal[itemValue]})"
              placeholder="enter the name to start search"
              return-object
            >
            </v-autocomplete>

             <v-expand-transition v-if="lazyVal">
              <v-list>
                <v-list-item>
                  <v-list-item-content v-for="(field, index) in fields" :key="index">
                    <v-list-item-title>{{field}}</v-list-item-title>
                    <v-list-item-subtitle>{{lazyVal[field]}}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-expand-transition>

          </v-card-text>
      </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
</template>

<style>
  .v-expansion-panel__container--active .pnc-card-headline {
    font-size: 24px;
    font-weight: regular;
  }
</style>

<script>
export default {
    props: {
        itemKey: String,
        headline: String,
        text: String,
        itemText: String,
        itemValue: String,
        query: Function,
        type: String,
        fields: Array,
        value: Object,
    },

    data() {
        return {
            loading: false,
            search: '',
            items: [],
            lazyVal: this.value
        }
    },

    watch: {
      search(val) {
        val && val !== this.select && this.doQuery(val)
      },
      value(val) {
        this.lazyVal = val
      },
      // selected(val) {
      //   this.items = [val]
      // }
    },

    methods: {
      doQuery(val) {
        this.loading = true


        this.query(val).then( data => {
          console.log('GOT DATA INSIDE COMPONENT!', data)

          this.items = data
          this.loading = false
        })
      }
    }
}
</script>


// WEBPACK FOOTER //
// IsrsPncTypeCard.vue?673b7848